import { render, staticRenderFns } from "./complainant_info.vue?vue&type=template&id=2fcb2786&scoped=true"
import script from "./complainant_info.vue?vue&type=script&lang=js"
export * from "./complainant_info.vue?vue&type=script&lang=js"
import style0 from "./complainant_info.vue?vue&type=style&index=0&id=2fcb2786&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcb2786",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fcb2786')) {
      api.createRecord('2fcb2786', component.options)
    } else {
      api.reload('2fcb2786', component.options)
    }
    module.hot.accept("./complainant_info.vue?vue&type=template&id=2fcb2786&scoped=true", function () {
      api.rerender('2fcb2786', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/complaintreporting/online/components/complainant_info.vue"
export default component.exports